export default __webpack_public_path__ + "static/media/head_to_head_rivalries_3.85ddb25d.png";